import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { TeasersContext, ITeasersContext } from 'modules/Teasers/Teasers/teasersState/teasersContext';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, IDSelectedCustomer, IDSelectedRestaurant, IDSelectedContentType } =
		useContext<ITeasersContext>(TeasersContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: IDSelectedContentType || IDSelectedCustomer || IDSelectedRestaurant,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
